const PropTypes = require('prop-types');

//@vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require("react-router-dom");
const ContractEasyLoanApprovedTypeCView = require('../contractEasyLoanApprovedTypeCView/contractEasyLoanApprovedTypeCView');
const ContractEasyLoanTypeCView = require('../contractEasyLoanTypeCView/contractEasyLoanTypeCView');
const { LoadingSection } = require('commonsComponents/loadingSection');

class ContractEasyLoanApprovedTypeCWrapper extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {

        const { immPayrollLoanRecordStatus, hiringProductBanners } = this.props
        const statusssss = immPayrollLoanRecordStatus.get('state');
        const isAccountBlockedValidationFetching = hiringProductBanners.get('isAccountBlockedValidationFetching');
        const isAccountBlockedValidationError = hiringProductBanners.get('isAccountBlockedValidationError');
        return (
            <>
                {
                    isAccountBlockedValidationFetching ?
                        <div className="contract-easy-loan-wrapper__loading"><LoadingSection /></div>
                        :
                        isAccountBlockedValidationError ?
                            <div className="container-fluid"><div className="contract-easy-loan-wrapper__error"><LoansError /></div></div>
                            :
                            statusssss === 'APROBADO' ? <ContractEasyLoanApprovedTypeCView /> : <ContractEasyLoanTypeCView />
                }
            </>
        )
    }
}

ContractEasyLoanApprovedTypeCWrapper.propTypes = {
    immContractEasyLoanTypeC: PropTypes.object.isRequired
};

module.exports.constructor = ContractEasyLoanApprovedTypeCWrapper;
module.exports = withRouter(connect(
    state => ({
        immContractEasyLoanTypeC: state.contractEasyLoanTypeC,
        immContractEasyLoanInit: state.contractInit,
        immPayrollLoanRecordStatus: state.loanRecordStatus,
        hiringProductBanners: state.hiringProductBanners,

    })
)(ContractEasyLoanApprovedTypeCWrapper));
